<template>
    <ul class="nav--submenu">
        <li class="nav--submenu__item nav--help">
            <a href="http://support.catenoid.net" class="nav-link tooltip-message" target="_blank"><i class="icon icon-que-circle-line"></i>{{ $t('words.help_center') }}</a>
        </li>
        <li class="nav--submenu__item dropdown">
            <a id="navbarServiceAccountDropdown" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <template v-if="!selectedServiceAccountName && haveServiceAccount">
                    <span class="fa fa-refresh fa-spin"></span> Loading...
                </template>
                <template v-else-if="!selectedServiceAccountName && !haveServiceAccount">
                    <i class="icon icon-alert-circle-line"></i>{{ $t('words.has_not_service_account') }}
                </template>
                <template v-else>
                    <i class="icon icon-sm icon-user"></i>{{ selectedServiceAccountName }}
                </template>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarServiceAccountDropdown">
                <template v-show="getServiceAccounts.length > 0">
<!--                    <div v-show="haveAdminRight" style="padding:10px;">-->
                    <div v-show="getServiceAccounts.length > optimizeLimit" style="padding:10px;">
                        <form>
                            <select id="select_service_account" :placeholder="$t('words.service_account')">
                                <!--<option value="">All Channels</option>-->
                                <!--<option :value="channel.id" v-for="channel in select.channels" :key="channel.id">{{ channel.title }}</option>-->
                            </select>
                            <!--                            <selectize v-model="selectizeServiceAccount" :settings="selectize_settings" :placeholder="$t('words.service_account')">-->
                            <!--                                <option :value="serviceAccount.key" v-for="serviceAccount in getServiceAccounts" :key="serviceAccount.key">-->
                            <!--                                    {{ serviceAccount.name }}-->
                            <!--                                </option>-->
                            <!--                            </selectize>-->
                        </form>
                    </div>
                    <div v-show="getServiceAccounts.length <= optimizeLimit">
<!--                    <div v-show="!haveAdminRight">-->
                        <a class="dropdown-item" href="#" v-for="serviceAccount in getServiceAccounts" :key="serviceAccount.key" @click.prevent="changeServiceAccount(serviceAccount)">
                            <i class="icon icon-sm icon-user"></i>{{ serviceAccount.name }}
                        </a>
                    </div>
                    <div class="dropdown-divider"></div>
                </template>
                <router-link class="dropdown-item" :to="{ name: 'cms-preferences-login_account' }">
                    <i class="icon icon-setting"></i>{{ getLoginAccount.name }} ({{ getRoleTrans(getLoginAccountRole) }})
                </router-link>
                <a class="dropdown-item" href="/logout"
                   onclick="event.preventDefault(); document.getElementById('logout-form').submit();"><i class="icon icon-logout"></i>{{ $t('words.logout') }}
                </a>
                <form id="logout-form" action="/logout" method="POST" style="display: none;">
                    <input type="hidden" name="_token" :value="csrf_token" />
                </form>
            </div>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import 'selectize';

// import Selectize from 'vue2-selectize';

export default {
    name: 'service-account-bar',
    // components: {
    //     Selectize,
    // },
    data() {
        return {
            // selectize_settings: {
            //     allowEmptyOption: true,
            //     place_holder: this.$t('words.service_account'),
            //     valueField: 'key',
            //     labelField: 'name',
            //     searchField: ['name', 'key'],
            //     preload: true,
            //     create: false,
            //     maxItems: 1,
            //     load: this._load,
            // },
            selectizeServiceAccount: null,
            optimizeLimit: 5,
            service_account: null,
            csrf_token: null,
            searchableServiceAccounts: null,
            selectServiceAccount: '',
        };
    },
    mounted() {
        const token = document.head.querySelector('meta[name="csrf-token"]');

        this.csrf_token = token.getAttribute('content');
        this.$store.dispatch('selectServiceAccount');

        this.loadServiceAccounts();
    },
    methods: {
        loadServiceAccounts() {
            const self = this;
            const selectizeObj = $('#select_service_account').selectize({
                allowEmptyOption: true,
                place_holder: this.$t('words.service_account'),
                valueField: 'key',
                labelField: 'name',
                searchField: ['name', 'key'],
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.selectServiceAccount = value;
                },
                load(query, callback) {
                    this.clearOptions();

                    self.selectServiceAccount = '';

                    const uri = `/cms/account/service_accounts?keyword=${encodeURI(query)}`;
                    axios.get(uri).then((response) => {
                        // self.$store.commit('SET_SERVICE_ACCOUNTS', response.data.data);
                        self.searchableServiceAccounts = response.data.data;
                        // response.data.data.unshift({ key: '', title: self.$t('words.service_account') });
                        callback(response.data.data);
                    }).catch((error) => {
                        self.$toasted.error('Failed to load service accounts');
                        // console.log(error.response.data.errors);
                        callback([{ key: '', title: self.$t('words.service_account') }]);
                    });
                },
            });

            this.selectizeServiceAccount = selectizeObj[0].selectize;
        },
        getRoleTrans(org) {
            if (org === 'owner' || org === 'manager' || org === 'viewer' || org === 'creator') {
                return this.$t(`words.role_${org}`);
            }
            return org;
        },
        async changeServiceAccount(serviceAccount) {
            await this.$store.dispatch('changeServiceAccount', { service_account: serviceAccount });
            localStorage.setItem('serviceAccount', serviceAccount.key);
            localStorage.removeItem('query');

            document.location.href = '/channels';

            // this.$cookie.set('service_account_key', serviceAccount.key, { expires: 7 });

            // this.$store.dispatch('changeServiceAccount', { service_account: serviceAccount }).then(() => {
            //     if (this.$router.currentRoute.name === 'cms-channel-list') {
            //         // this.$store.dispatch('loadChannels');
            //     } else if (this.$router.currentRoute.name === 'cms-channel-view') {
            //         // TODO change vue router cms-channel-list
            //         // this.$store.dispatch('loadChannels');
            //     } else if (this.$router.currentRoute.name === 'cms-channel-recording-files') {
            //         // this.$store.dispatch('loadBroadcasts');
            //     }
            // });
        },
    },
    computed: {
        ...mapGetters([
            'selectedServiceAccount',
            'getServiceAccounts',
            'getLoginAccount',
            'haveServiceAccount',
            'getLoginAccountRole',
        ]),
        selectedServiceAccountName() {
            return typeof this.selectedServiceAccount === 'undefined' ? null : this.selectedServiceAccount.name;
        },
        haveAdminRight() {
            return typeof this.getLoginAccountRole !== 'undefined' && (this.getLoginAccountRole === 'kollus administrator' ||
                this.getLoginAccountRole === 'partner administrator');
        },
    },
    watch: {
        selectedServiceAccount(newValue) {
            if (typeof newValue !== 'undefined') {
                this.service_account = newValue.key;
            }
        },
        selectServiceAccount(newValue) {
            // 이미 선택된 서비스 계정을 다시 선택하는 경우에 대한 예외 처리하지 않도록 수정
            if (typeof newValue !== 'undefined' && newValue !== '') {
                const serviceAccount = _.find(this.searchableServiceAccounts, currentAccount => (currentAccount.key === newValue));
                if (typeof serviceAccount !== 'undefined') {
                    this.service_account = serviceAccount.key;
                    this.changeServiceAccount(serviceAccount);
                }
            }
        },
    },
};
</script>

<style scoped>
.dropdown-menu-right {
    top: auto !important;
    left: auto !important;
    right: 0 !important;
    transform: none !important;
}
.dropdown-menu-right::v-deep input {
    width: 100% !important;
}
</style>

